const ENV_NAME = process.env["NEXT_PUBLIC_ENV_NAME"] || "";

export const checkIfDev = () =>
  ["development", "development-int"].includes(ENV_NAME);
export const checkIfTest = () => ["test"].includes(ENV_NAME);

export default checkIfDev;
